import type { Dispatch, SetStateAction } from 'react';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notification } from 'antd';

import api from '../../../utils/api';
import { GET_SPECIALIZATIONS_QUERY_KEY } from './useCreateSpecializationMutation';

interface DeleteSpecializationResponse {
  code: number;
  message: string;
  data?: unknown;
}

export const useDeleteSpecializationMutation = (
  id: number,
  setOpenDelete?: Dispatch<SetStateAction<boolean>>,
) => {
  const queryClient = useQueryClient();

  const deleteSpecialization = async (): Promise<DeleteSpecializationResponse> => {
    return (await api.delete(`/Concentration/${id}`))?.data;
  };

  const mutation = useMutation({
    mutationKey: ['delete-specialization', id],
    mutationFn: deleteSpecialization,
    onSuccess: (data) => {
      notification.success({
        message: 'Success',
        description: data?.message || 'Specialization deleted successfully',
      });

      queryClient.invalidateQueries({
        queryKey: GET_SPECIALIZATIONS_QUERY_KEY,
      });

      setOpenDelete?.(false);
    },
    onError: (error: any) => {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message || error?.response?.data?.title || 'Failed to delete specialization',
      });
    },
  });

  const deleteSpecializationHandler = async () => {
    return mutation.mutateAsync();
  };

  return {
    deleteSpecializationHandler,
    isDeleteLoading: mutation.isPending,
  };
};
